export default {
  env: process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development',
  DOCS_URL: `${process.env.PUBLIC_URL}/manual_v15122022.pdf`,
};
